import React, { useState, useEffect, useContext } from "react";
import "./homeScreen.css";
import moment from "moment";
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import {
  deleteTransriptByID,
  getAllTranscripts,
} from "../../services/transcriptService";
import { toast, ToastContainer } from "react-toastify";
import Table from "../../components/Table/Table";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import AuthContext from "../../store/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";

function HomeScreen() {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [meetings, setMeetings] = useState([]);
  const [allMeetings, setAllMeetings] = useState([]);

  const [transcriptId, setTrancriptId] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [functionData, setFunctionData] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialSearchTerm = queryParams.get("searchValue") || "";
  const initialPageNumber = queryParams.get("pageValue") || 1;
  const initialRowPerPage = queryParams.get("rowsPerPage") || 10;
  const initialSortBy = queryParams.get("sortBy") || "createdAt";
  const initialSortorder = queryParams.get("sortOrder") || "desc";
  const initialStartDate = queryParams.get("startDate") || null;
  const initialEndDate = queryParams.get("endDate") || null;
  const initialPlatformSelected = queryParams.get("platform") || "";

  const [state, setState] = useState([
    { startDate: initialStartDate, endDate: initialEndDate, key: "selection" },
  ]);

  const [rowsPerPage, setRowsPerPage] = useState(Number(initialRowPerPage));
  const [pageNumber, setPageNumber] = useState(Number(initialPageNumber));
  const [totalRows, setTotalRows] = useState(0);
  const [searchKeyWord, setSearchKeyWord] = useState(initialSearchTerm);
  const [sortBy, setSortBy] = useState(initialSortBy);
  const [sortOrder, setSortOrder] = useState(initialSortorder);
  const [platformSelected, setPlatformSelected] = useState(
    initialPlatformSelected
  );

  useEffect(() => {
    const getTranscripts = async () => {
      const queryParams = new URLSearchParams({
        rowsPerPage: rowsPerPage,
        pageNumber: pageNumber,
        sortBy: sortBy,
        sortOrder: sortOrder,
        startDate: state[0].startDate,
        endDate: state[0].endDate,
        searchKeyWord: searchKeyWord,
        platform: platformSelected,
        lastId: meetings.length ? meetings[meetings.length - 1].id : undefined,
      });

      setLoading(true);

      try {
        const res = await getAllTranscripts(queryParams);
        if (res?.status === "success") {
          setLoading(false);
          setAllMeetings(
            res?.result?.transcriptions ? res?.result?.transcriptions : []
          );
          setTotalRows(res?.result?.totalRows ? res?.result?.totalRows : 0);
          setMeetings(res?.result?.transcriptions);
        } else throw new Error("Fetching Failed");
      } catch (e) {
        setLoading(false);
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    getTranscripts();
    // eslint-disable-next-line
  }, [
    rowsPerPage,
    pageNumber,
    sortBy,
    sortOrder,
    state,
    searchKeyWord,
    platformSelected,
  ]);

  const manageSortBy = (a, b) => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    searchParams.set("sortBy", a);
    searchParams.set("sortOrder", b);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);

    setSortBy(a);
    setSortOrder(b);
  };

  const handleSearchKeyword = (searchInput) => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set("searchValue", searchInput);
    searchParams.set("pageValue", 1);
    searchParams.set("rowsPerPage", 10);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);
    setSearchKeyWord(searchInput);
    setRowsPerPage(10);
    setPageNumber(1);
  };

  const handleDateChange = (dateChanged) => {
    setState(dateChanged);

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    searchParams.set("rowsPerPage", 10);
    searchParams.set("pageValue", 1);
    searchParams.set("startDate", dateChanged[0].startDate);
    searchParams.set("endDate", dateChanged[0].endDate);

    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);

    setRowsPerPage(10);
    setPageNumber(1);
  };

  const PageChange = (val) => {
    setPageNumber(val);
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set("pageValue", val);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);
  };

  const handleChangePlatform = (val) => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set("platform", val);
    searchParams.set("rowsPerPage", 10);
    searchParams.set("pageValue", 1);
    setRowsPerPage(10);
    setPageNumber(1);
    setPlatformSelected(val);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);
  };

  console.log({
    rowsPerPage: rowsPerPage,
    pageNumber: pageNumber,
    sortBy: sortBy,
    sortOrder: sortOrder,
    startDate: state[0].startDate,
    endDate: state[0].endDate,
    searchKeyWord: searchKeyWord,
    platform: platformSelected,
  });

  return (
    <>
      <ToastContainer />
      {isOpen && (
        <ConfirmModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          functionData={functionData}
          setLoading={setLoading}
          setUploads={setMeetings}
          setFunctionData={setFunctionData}
        />
      )}
      <NavBar />
      <div style={{ display: "grid", gridTemplateColumns: "200px 1fr" }}>
        <SideBar />
        <div
          style={{
            flexGrow: "1",
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            background: "#F8F8F8",
          }}
        >
          {loading ? (
            <div id="svg-container">
              <RotatingLines
                visible={true}
                height="96"
                width="96"
                color="red"
                strokeColor="grey"
                strokeWidth="4"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <div style={{ padding: "20px 50px", borderRadius: "10px" }}>
              <Table
                totalRows={totalRows}
                pageNumber={pageNumber}
                setRowsPerPage={(data) => {
                  setRowsPerPage(data);
                  const url = new URL(window.location.href);
                  const searchParams = new URLSearchParams(url.search);

                  searchParams.set("rowsPerPage", data);
                  url.search = searchParams.toString();
                  window.history.pushState({ path: url.href }, "", url.href);
                }}
                correctIcon={false}
                sortOrderPrev={sortOrder}
                rowsPerPage={rowsPerPage}
                setPageNumber={PageChange}
                data={meetings}
                pending={loading}
                setTrancriptId={setTrancriptId}
                searchKeyWord={searchKeyWord}
                setSearchKeyWord={setSearchKeyWord}
                state={state}
                dontShow={false}
                setState={setState}
                setIsOpen={setIsOpen}
                setFunctionData={setFunctionData}
                manageSortBy={manageSortBy}
                handleDateChange={handleDateChange}
                handleSearchKeyword={handleSearchKeyword}
                platformSelected={platformSelected}
                handleChangePlatform={handleChangePlatform}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default HomeScreen;
